module.exports = __webpack_public_path__ + "img/am.3b51321b.svg";